import React from 'react';
import { Select } from '@agconnections/grow-ui';
import PropTypes from 'prop-types';

const ProductListTypeFilter = ({
  width = '100%',
  typeFilters,
  handleFilterChange,
  typeFilterOptions
}) => (
  <div className="font-medium h-8 whitespace-nowrap" style={{ width }}>
    <Select
      multiple
      id="ProductTypeSelector"
      value={typeFilters.join(',')}
      placeholder="Filter by type"
      items={typeFilterOptions}
      onChange={handleFilterChange}
    />
  </div>
);

ProductListTypeFilter.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  typeFilters: PropTypes.arrayOf(PropTypes.object).isRequired,
  typeFilterOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleFilterChange: PropTypes.func.isRequired
};
export default ProductListTypeFilter;
